import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onReset) {
      this.props.onReset();
    } else {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[220px] w-full p-6 flex flex-col items-center justify-center text-center bg-slate-950 text-white rounded-3xl border border-rose-500/40 my-3 shadow-2xl">
          <div className="w-12 h-12 rounded-2xl bg-rose-500/20 text-rose-400 flex items-center justify-center text-2xl font-black mb-3">
            ⚠️
          </div>
          <h3 className="text-sm sm:text-base font-bold text-white mb-1">
            Görsel Yükleme Bildirimi / Foutmelding
          </h3>
          <p className="text-xs text-slate-400 max-w-md mb-2 leading-relaxed">
            Bu bölüm yüklenirken beklenmeyen bir durum oluştu. Lütfen butona tıklayarak yeniden deneyin.
          </p>
          {this.state.error && (
            <div className="w-full max-w-xl p-3 mb-4 rounded-xl bg-slate-900 border border-rose-500/50 text-rose-300 font-mono text-xs text-left overflow-auto max-h-40">
              <div className="font-bold text-rose-400 mb-1">{this.state.error.toString()}</div>
              <div className="text-[10px] text-slate-400 whitespace-pre-wrap">{this.state.error.stack}</div>
            </div>
          )}
          <button
            onClick={this.handleReset}
            type="button"
            className="px-5 py-2.5 rounded-xl bg-amber-500 hover:bg-amber-400 text-slate-950 font-black text-xs transition-all shadow-lg cursor-pointer"
          >
            Yenile & Tekrar Dene
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
